import { AdTemplate } from "../AdTemplate";
export class AdTemplateCreateRequest  extends AdTemplate {

}

